<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>
    <div class="flex">
      <ToastAlert
        :is-active="toastAlert"
        :type="typeMsg"
        :message="msg"
      />
    </div>
    <!-- Información general -->
    <div class="sm:w-[380px]">
      <div
        v-if="!loader"
        class="flex flex-col space-y-4"
      >
        <p class="text-lg font-medium text-black">Información general</p>
        <div class="flex flex-1 justify-center items-center">
          <div class="w-full">
            <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Nombre de propiedad *</p>
            <input
              v-model="property_name"
              type="text"
              placeholder="Ingresa el nombre para la propiedad"
              class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
            />
          </div>
        </div>

        <div class="flex flex-1 justify-center items-center">
          <div class="w-full">
            <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Tipo de propiedad *</p>
            <select
              v-model="type_property_id"
              class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full"
            >
              <option disabled :value="null">Selecciona tipo de propiedad</option>
              <option
                v-for="option in dic_properties"
                :key="option.value"
                :value="option.value"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="flex flex-1 justify-center items-center">
          <div class="w-full">
            <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Tipo de operación *</p>
            <select
              v-model="type_movement_id"
              class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full"
            >
              <option disabled :value="null">Selecciona una opción</option>
              <option
                v-for="option in dic_movements"
                :key="option.value"
                :value="option.value"
              >{{ option.name }}</option>
            </select>
          </div>
        </div>

        <div class="flex flex-1 items-center">
          <div class="flex flex-col w-full">
            <!-- Etiqueta dinámica -->
            <p
              class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
            >
              {{ type_property_id === 9 ? 'Fecha de disponibilidad *' : 'Fecha de disponibilidad' }}
            </p>

            <!-- Componente VueDatePicker -->
            <div class="flex relative pt-[-5px]">
              <VueDatePicker
                v-model="date_available"
                :enable-time-picker="false"
                :locale="es"
                class="w-full"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Fin del bloque información general -->
      <div class="hidden mt-6 flex-col-1 justify-end items-end">
        <button
          class="w-full sm:w-auto px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-tuin-100 hover:bg-tuin_hover transition-colors"
          @click="save()"
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { es } from "date-fns/locale";
import VueDatePicker from "@vuepic/vue-datepicker";
import LoaderTuin from "@/commond/LoaderTuin.vue";
import ToastAlert from "@/commond/ToastAlert.vue";
import axios from "axios";


import { ref, onMounted, computed, watch, defineEmits } from "vue";
const props = defineProps({
  resp: {
    type: Object,
    required: true,
    default: () => ({ property_name: '' })
  },
  propertyId: {
    type: Number,
    required: true,
    default: 0
  },
  isAvailable: {
    type: Boolean,
    default: false
  }
});


import { useRouter } from "vue-router";
let router = useRouter();
import { useRoute } from 'vue-router';
const route = useRoute();
import { useStore } from "vuex";
let store = useStore();
let loader = ref(false);
let session = computed(() => store.getters.getUserSession);
//import axios from "axios";

let property_name         = ref();
let type_movement_id      = ref(1);
let type_property_id      = ref("");
let date_available        = ref("");

// Definimos la variable reactiva que controla la visibilidad de la modal.
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

let dic_properties = ref([]);
let dic_movements = ref([]);

let resp_property_id = ref(0);
const emit = defineEmits(['triggerUpdate']);
/*
const showAdvisorsNotificationValue = computed({
  get() {
    if (type_movement_id.value === 1) return share_commission.value === 'true';
    if (type_movement_id.value === 2) return share_commission_rent.value === 'true';
    if (type_movement_id.value === 3) return share_commission.value === 'true' || share_commission_rent.value === 'true';
    return false;
  },
  set(val) {
    if (type_movement_id.value === 1) share_commission.value = val ? 'true' : 'false';
    else if (type_movement_id.value === 2) share_commission_rent.value = val ? 'true' : 'false';
    else if (type_movement_id.value === 3) {
      if (!share_commission.value || !share_commission_rent.value) {
        if (!share_commission.value) share_commission.value = val ? 'true' : 'false';
        if (!share_commission_rent.value) share_commission_rent.value = val ? 'true' : 'false';
      }
    }
  }
});*/
// Función para validar que solo se ingresen números
function adjustTimezone(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
}
async function save() {
  let validation = await validate_form();
  if (!validation.status) {
    showToast("danger", validation.message);
    return;
  }

  let previousMovementId = null;
  if (props.resp && props.resp.type_movement_id) {
    previousMovementId = Number(props.resp.type_movement_id);
  }
  
  // Convertir el nuevo valor a número para comparación
  const newMovementId = Number(type_movement_id.value);

  // Obtener el tipo de movimiento anterior
 /*  const previousMovementId = props.resp ? props.resp.type_movement_id : null; */

  // Buscar los nombres de type_movement y type_property
  const selectedMovement = dic_movements.value.find(m => m.value === type_movement_id.value);
  const selectedProperty = dic_properties.value.find(p => p.value === type_property_id.value);

  let post_params = {
    property_name: property_name.value,
    type_movement_id: type_movement_id.value,
    type_property_id: type_property_id.value,
    type_movement: selectedMovement ? selectedMovement.name : '',
    type_property: selectedProperty ? selectedProperty.name : '',
    ...(date_available.value && {
      date_available: (() => {
        const date = new Date(date_available.value);
        const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        return utcDate.toISOString().split("T")[0];
      })(),
    }),
    broker_id: session.value.id,
  };

  let isUpdating = false;

  if (props.propertyId != 0) {
    post_params["property_id"] = props.propertyId;
    isUpdating = true;
  }

  if (resp_property_id.value != 0) {
    post_params["property_id"] = resp_property_id.value;
    isUpdating = true;
  }

  let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${session.value.id}/save_info_general`;

  let options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url, post_params, options);

    if (response.status === 200) {
      showToast("success", response.data.message);
      let updatedPropertyId = response.data.resp.id;
      emit("triggerUpdate", updatedPropertyId);

      // Verificar si el tipo de movimiento cambió a 5
      const isNowAuction = newMovementId === 5;
      const wasNotAuctionBefore = previousMovementId !== 5;

      console.log("[DEBUG] Comparación numérica:");
      console.log("[DEBUG] isNowAuction (newMovementId === 5):", isNowAuction);
      console.log("[DEBUG] wasNotAuctionBefore (previousMovementId !== 5):", wasNotAuctionBefore);

      if (isUpdating && isNowAuction) {
        console.log("[DEBUG] Llamando notificaciones porque es tipo 5...");
        await callAuctionNotifications(updatedPropertyId);
      }

      router.push({ name: "propertyFormEdit", params: { id: updatedPropertyId } });
      
      // If is updating, sync with external services
      if (isUpdating && props.isAvailable) {
        await syncWithPropiedades(updatedPropertyId);
        await syncWithEasyBroker(updatedPropertyId);
      }
      return true;
    } else {
      console.log("Error en la respuesta: ", response.status);
      return false;
    }
  } catch (error) {
    console.log("Error en la solicitud:", error);
    if (error.response && error.response.status === 401) {
      store.dispatch("clearUserSession");
      router.push({ name: "login" });
    }
    return false;
  }
}
// Función para llamar a las notificaciones de remate
  async function callAuctionNotifications(propertyId) {
      try {
          const notificationUrl = `${process.env.VUE_APP_API_BASE_URL}/auction-notice/${propertyId}`;
          const slackNotificationUrl = `${process.env.VUE_APP_API_BASE_URL}/slack-auction/${propertyId}`;
          
          const options = {
              headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${session.value.token_api}`,
              },
          };

          // Llamar a la notificación de Hilos
          await axios.post(notificationUrl, {}, options);
          console.log("[AUCTION NOTICE] Notificación de Hilos enviada");
          
          // Llamar a la notificación de Slack
          await axios.post(slackNotificationUrl, {}, options);
          console.log("[AUCTION NOTICE] Notificación de Slack enviada");
          
          showToast("success", "Notificaciones de remate enviadas");
          
      } catch (error) {
          console.error("[ERROR IN AUCTION NOTIFICATIONS]", error.response);
          showToast("warning", "Notificaciones de remate no enviadas");
      }
  }
async function syncWithPropiedades(propertyId) {
  let syncUrl = `${process.env.VUE_APP_API_BASE_URL}/propertiesComUpdate/${propertyId}`;

  let syncOptions = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const syncResponse = await axios.put(syncUrl, {}, syncOptions);
    if (syncResponse.status === 200) {
      console.log("success", "Propiedad sincronizada con propiedades.com");
    } else {
      console.log("Error en sincronización: ", syncResponse.status);
    }
  } catch (error) {
    console.log("Error en sincronización:", error);
  }
}
async function syncWithEasyBroker(propertyId) {
  let url_sync = `${process.env.VUE_APP_API_BASE_URL}/editar-easybroker/${propertyId}`;

  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${session.value.token_api}`,
    },
  };

  try {
    const response = await axios.post(url_sync, {}, options);

    // Validar que el código sea 200 y además el contenido indique éxito
    if (
      response.status === 200 &&
      Array.isArray(response.data) &&
      response.data[0]?.status === "success"
    ) {
      console.log("[SYNC SUCCESS]", response.data);
      showToast("success", "Propiedad sincronizada con EasyBroker");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      console.warn("[SYNC WARNING] Error en respuesta:", response.data);
    }

  } catch (error) {
    console.error("[ERROR SYNCING WITH EASYBROKER]", error.response);
    showToast("error", "Error al sincronizar con EasyBroker");
  }
}
async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}
 
async function validate_form() {
  
  if(property_name.value  == undefined || property_name.value  == ''){
    return { "status": false, "message": "El campo nombre de propiedad es obligatorio."}    
  }

  if(type_property_id.value  == undefined || type_property_id.value  == ''){
    return { "status": false, "message": "El campo tipo de propiedad es obligatorio."}    
  }

  if(type_movement_id.value  == undefined || type_movement_id.value  == ''){
    return { "status": false, "message": "El campo tipo de operación es obligatorio."}    
  }

  if(type_property_id.value === 9 && (!date_available.value)) {
    return { "status": false, "message": "El campo fecha de disponibilidad es obligatorio para este tipo de propiedad."}    
  }

  return { "status": true, "message": "Todo esta bien "}    

}

async function getDicProperties() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_property`;
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.get(url, options);

  if (response.status == 401) {
    store.dispatch("clearUserSession");
  }

  if (response.status == 200) {
    const formattedData = response.data.resp.map((item) => ({
      value: item.id,
      name: item.name,
    }));
    dic_properties.value = formattedData;
    // filteredProperties.value = response.data.resp;
  }
}

async function getDicTypeMovement() {
  let url = `${process.env.VUE_APP_API_BASE_URL}/catalogue/type_movement_property`;
  let options = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const response = await axios.get(url, options);

  if (response.status == 401) {
    store.dispatch("clearUserSession");
  }

  if (response.status == 200) {
    const formattedData = response.data.resp.map((item) => ({
      value: item.id,
      name: item.name,
    }));
    dic_movements.value = formattedData;
    // filteredProperties.value = response.data.resp;
  }
}

onMounted(async () => {
  loader.value = true;
  await getDicProperties();
  await getDicTypeMovement();
  loader.value = false;
});

watch(
  () => props.resp,
  (newVal) => {
    property_name.value = newVal ? newVal.property_name : '';
    type_movement_id.value = newVal ? newVal.type_movement_id: '';
    type_property_id.value = newVal ? newVal.type_property_id: '';
    date_available.value = newVal && newVal.date_available ? adjustTimezone(newVal.date_available) : '';
  },
  { immediate: true }
);
watch(
  () => route.params.id,
  (newId) => {
    if (newId) {
      resp_property_id.value = parseInt(newId);
    }
  },
  { immediate: true }  // Esto hace que se ejecute inmediatamente al montar el componente
);

// Exponer el método save para que pueda ser llamado desde el componente padre
defineExpose({
  save,
  callAuctionNotifications
});

</script>


<style scoped>
/* Animación personalizada */
@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fade-in {
  animation: fade-in 0.5s ease-in-out;
}

/* Personalización de VueDatePicker con colores tuin-100 */
:deep(.dp__theme_light) {
    --dp-background-color: #fff;
    --dp-text-color: #737373;
    --dp-hover-color: #f3f3f3;
    --dp-hover-text-color: #737373;
    --dp-hover-icon-color: #737373;
    --dp-primary-color: #FF4265;
    --dp-primary-disabled-color: #6bacea;
    --dp-primary-text-color: #f8f5f5;
    --dp-secondary-color: #c0c4cc;
    --dp-border-color: #ddd;
    --dp-menu-border-color: #ddd;
    --dp-border-color-hover: #FF4265;
    --dp-border-color-focus: #FF4265;
    --dp-disabled-color: #f6f6f6;
    --dp-scroll-bar-background: #f3f3f3;
    --dp-scroll-bar-color: #737373;
    --dp-success-color: #76d275;
    --dp-success-color-disabled: #a3d9b1;
    --dp-icon-color: #737373;
    --dp-danger-color: #ff6f60;
    --dp-marker-color: #ff6f60;
    --dp-tooltip-color: #fafafa;
    --dp-disabled-color-text: #8e8e8e;
    --dp-highlight-color: rgb(25, 118, 210);
    --dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);
    --dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);
    --dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);
    --dp-input-padding: 9px 42px 9px 16px; /*Padding in the input*/
    --dp-border-radius: 8px; /*Configurable border-radius*/
}
</style>